import { PlannedRouteTrail } from 'atlasguides-web-common/src/functions/guides/dto/guide-geo.dto';
import { PlannedRouteExt } from 'commonTypes/GuideUse/guideGeo';


export const getPlannedRouteById = (id: string, plannedRoutes: PlannedRouteExt[]): PlannedRouteExt | null => {
    for (let i = 0; i < plannedRoutes.length; i++) {
        if (plannedRoutes[i].id === id) {
            return plannedRoutes[i];
        }
    }
    return null;
}

export const getEnabledPlannedRoute = (plannedRoutes: PlannedRouteExt[]): PlannedRouteExt | null => {
    const routeId = getEnabledPlannedRouteId();
    if (routeId != null) {
        return getPlannedRouteById(routeId, plannedRoutes);
    }
    return null;
}

export const setEnabledPlannedRoute = (plannedRoute: PlannedRouteExt, plannedRoutes: PlannedRouteExt[], isEnabled: boolean ) => {
    localStorage.removeItem('selectedPlannedRoute');

    for (let i = 0; i < plannedRoutes.length; i++) {
        if (plannedRoutes[i].id === plannedRoute.id) {
            plannedRoutes[i].isEnabled = isEnabled;
            if (isEnabled){
                localStorage.setItem('selectedPlannedRoute', plannedRoutes[i].id);
            }
        }
        else{
            plannedRoutes[i].isEnabled = false;
        }
    }
}

export const updatePlannedRouteInfoByTrail = (plannedRoute: PlannedRouteExt, plannedRoutes: PlannedRouteExt[], trail: PlannedRouteTrail) => {
    for (let i = 0; i < plannedRoutes.length; i++) {
        if (plannedRoutes[i].id === plannedRoute.id) {

            let statePlannedRoute = plannedRoutes[i]
            
            statePlannedRoute.trail = trail;

            if (statePlannedRoute.routeLength === 0){
                statePlannedRoute.routeLength = trail.trackLength;
            }

            if (statePlannedRoute.totalAscent === 0 && statePlannedRoute.totalDescent === 0){
                statePlannedRoute.totalAscent = trail.totalAscent;
                statePlannedRoute.totalDescent = trail.totalDescent;
            }

            break;
        }
    }
}

export const getEnabledPlannedRouteId = (): string | null => {
    return localStorage.getItem('selectedPlannedRoute')
}
